<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<header>
<h1 class="topictitle1" id="de1"><a href="#/nav#nde1"><span class="title"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Dedication</span></span></a></h1>
</header>
<div class="dedication_group">
<p class="dedication">To my father, Charles Hughley. I’ll always try to make you proud.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?ee723e7c